import { render, staticRenderFns } from "./global.vue?vue&type=template&id=29e7f776&scoped=true"
import script from "./global.vue?vue&type=script&setup=true&lang=js"
export * from "./global.vue?vue&type=script&setup=true&lang=js"
import style0 from "./global.vue?vue&type=style&index=0&id=29e7f776&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e7f776",
  null
  
)

export default component.exports